import { combineReducers } from 'redux';
import searchResultReducer from './search-result';

const homeReducer = combineReducers({
  searchResult: searchResultReducer,
})

export default homeReducer;
